import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { profile } from '../../redux/AuthSlice';
import { Card, CardContent, CardMedia, Typography } from '@mui/material';
import { getProfileImage } from '../../helper/Helper';

function Profile() {
    const { profileData, isLoading } = useSelector((state) => state.authKey)
   

    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(profile());
    }, [dispatch])
    return (
        <>
            {!isLoading && profileData &&
                <Card sx={{ maxWidth: 400, margin: '40px auto' }}>
                    <Typography sx={{margin:'20px 0', textAlign:"center"}} variant='h5' >My Profile</Typography>
                    <CardContent>
                        <CardMedia
                            sx={{ height: 140, width: 140, margin: "auto", borderRadius: 200, border: "5px solid #134B70" }}
                            image={getProfileImage(profileData?.profile_pic)}
                            title={profileData?.first_name}
                        />

                        <Typography sx={{ textAlign:"center" }} variant="h5" component="div">
                            {profileData?.first_name} {profileData.last_name}
                        </Typography>
                        <Typography sx={{ textAlign:"center" }}>{profileData.email}</Typography>

                    </CardContent>

                </Card>
            }
        </>
    );
}

export default Profile;
